<template>
  <div v-if="canSelectContact">
    <v-btn v-bind="btnProps" @click="selectContact">
      {{ btnLabel }}
      <slot name="btn"></slot>
    </v-btn>
    <v-dialog v-model="dialog" max-width="400" content-class="rounded-lg">
      <v-card>
        <v-card-title>Selecione o número de telefone </v-card-title>
        <v-card-text>
          <p>
            Algumas pessoas possuem mais de um número de telefone. Selecione o
            número de telefone que você deseja usar.
          </p>
          <v-list>
            <v-list-item v-for="(contact, index) in contacts" :key="index">
              <v-list-content>
                <v-list-item-title>
                  <h6 class="mb-0">
                    {{ contact?.name?.[0] }}
                  </h6>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <v-radio-group v-model="selectedContact[index]">
                    <v-radio
                      v-for="(tel, yndex) in contact?.tel || []"
                      :key="yndex"
                      :value="yndex"
                      :label="tel.phone"
                    />
                  </v-radio-group>
                </v-list-item-subtitle>
              </v-list-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="select">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    loading: false,
    contacts: [],
    selectedContact: [],
    canSelectContact: "contacts" in navigator && "select" in navigator.contacts,
  }),
  props: {
    btnProps: {
      type: Object,
      default: () => ({}),
    },
    btnLabel: {
      type: String,
      default: "Selecionar contato",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    interestedFields: {
      type: Array,
      default: () => ["name", "tel"],
    },
  },
  methods: {
    select() {
      const contacts = this.contacts.map((contact, index) => {
        return {
          name: contact?.name?.[0],
          tel: contact.tel[this.selectedContact[index] || 0],
        };
      });
      this.$emit("select", contacts);
    },
    async selectContact() {
      try {
        this.$emit("initSelect");
        this.loading = true;
        this.selectedContact = [];

        const contacts = await navigator.contacts.select(
          this.interestedFields,
          { multiple: this.multiple }
        );
        if (!contacts) return;

        var isAmbiguous = false;
        const parsedContacts = contacts
          .map(this.parseContact)
          .filter((contact) => {
            if (!isAmbiguous) {
              isAmbiguous = this.interestedFields.some(
                (field) => (contact[field] || [])?.length > 1
              );
            }
            const isValid = this.interestedFields.every(
              (field) => contact[field]?.length !== 0
            );
            return isValid;
          });

        if (parsedContacts.length === 0) return;
        this.contacts = parsedContacts;

        if (!isAmbiguous) return this.select();

        this.selectedContact = new Array(parsedContacts.length).fill(0);
        this.dialog = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    parseContact(contact) {
      const interestedFields = this.interestedFields;
      const phones = new Map();
      contact.tel.forEach((tel) => {
        const parsedTel = this.parseTel(tel);
        if (parsedTel)
          phones.set(`${parsedTel.ddi}${parsedTel.phone}`, parsedTel);
      });
      return {
        name: interestedFields.includes("name") ? contact?.name : undefined,
        tel: interestedFields.includes("tel")
          ? Array.from(phones.values())
          : undefined,
      };
    },
    parseTel(tel) {
      var numberOnly = `${tel}`.replace(/\D/g, "");
      var ddi = 55;
      if (numberOnly.startsWith("55")) numberOnly = numberOnly.slice(2);
      if (numberOnly.length < 10) return null;
      if (numberOnly.length === 10) {
        const ddd = numberOnly.slice(0, 2);
        const number = numberOnly.slice(2);
        numberOnly = `${ddd}9${number}`;
      } else if (numberOnly.length > 11) return null;
      return {
        ddi,
        phone: this.formatTel(numberOnly),
      };
    },
    formatTel(number) {
      return `(${number.slice(0, 2)}) ${number.slice(2, 7)}-${number.slice(7)}`;
    },
  },
};
</script>
